import { Parameter_Ring_Bool_Exp } from 'generated/graphql';
import { DateRangeValue } from 'technical/types';

/**
 * Builds the `_or` filter shared by ring/list and steering/table so that
 * a given "Jour"/"Période" filter selects the same rings on both screens:
 * a ring matches as soon as one of its 4 business dates falls in the range.
 */
export const buildParameterRingDateOrFilter = (
  dateRange: DateRangeValue | null | undefined,
): Parameter_Ring_Bool_Exp['_or'] => {
  if (!dateRange) {
    return undefined;
  }

  const [min, max] = dateRange;
  const dateCondition = {
    _gte: min === null || min === undefined ? undefined : min.toISOString(),
    _lte: max === null || max === undefined ? undefined : max.toISOString(),
  };

  return [
    { excavationStart: dateCondition },
    { excavationEnd: dateCondition },
    { buildStart: dateCondition },
    { buildEnd: dateCondition },
  ];
};
